export default __webpack_public_path__ + "static/media/grafema_clivitalbio_15.44aba3a8.jpg";